module.exports = __webpack_public_path__ + "img/20_121.4b407f19.png";